export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4652.240d65b0.jpg";